import React, { useState, ChangeEvent } from "react";
import { useNavigate } from "react-router-dom";
import {
    Tabs,
    Tab,
    TextField,
    Button,
    MenuItem,
    Select,
    SelectChangeEvent,
    CardMedia,
    Input,
    Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

const AddVendor = () => {
    const navigate = useNavigate();

    const [tabIndex, setTabIndex] = useState(0);
    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabIndex(newValue);
    };

    const [image, setImage] = useState<string>("");
    const [fileName, setFileName] = useState<string>("");

    const [country, setCountry] = useState("default");
    const [state, setState] = useState("default");
    const [city, setCity] = useState("default");

    return (
        <>
            <div className="main_title">
                <h1>Add Vendor</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate("/manage-vendors")}>Manage Vendors</button> - Add Vendor
                </p>
            </div>



            <div className="cards">
                <div className="form">
                    <div className="gap_p">
                        {/* Store Image */}
                        <div className="control_group w_100">
                            <label htmlFor="vendor-logo">Image</label>
                            {image ? (
                                <div className="upload_image">
                                    <div className="upload_image_holder no_radius">
                                        <figure>
                                            <CardMedia component="img" image={image} alt="Store Logo" />
                                        </figure>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                setImage("");
                                                setFileName("");
                                            }}
                                            style={{ border: 'none', background: 'transparent', cursor: 'pointer', padding: 0 }}
                                            aria-label="Remove image"
                                        >
                                            <CloseIcon />
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <Input
                                        sx={{ display: "none" }}
                                        id="vendor-logo"
                                        type="file"
                                        inputProps={{ accept: "image/png,image/jpeg" }}
                                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                            const files = e.target.files;
                                            if (files && files[0]) {
                                                setFileName(files[0].name);
                                                setImage(URL.createObjectURL(files[0]));
                                            }
                                        }}
                                    />
                                    <label className="upload_image" htmlFor="vendor-logo">
                                        <span className="upload_image_holder no_radius">
                                            <figure className="add_img">
                                                <img src="/static/images/placeholder.png" alt="placeholder" />
                                                <span className="upload_img_icon">
                                                    <img src="/static/images/edit2_icon.svg" alt="edit" />
                                                </span>
                                            </figure>
                                        </span>
                                    </label>
                                </>
                            )}
                        </div>

                        {/* Short Name */}
                        <div className="control_group w_50">
                            <label htmlFor="short_name">Short Name</label>
                            <TextField id="short_name" placeholder="Enter Short Name" fullWidth />
                        </div>

                        {/* Store Name */}
                        <div className="control_group w_50">
                            <label htmlFor="store_name">Store Name</label>
                            <TextField id="store_name" placeholder="Enter Store Name" fullWidth />
                        </div>

                        {/* Contact Email */}
                        <div className="control_group w_50">
                            <label htmlFor="contact_email">Contact Email</label>
                            <TextField id="contact_email" placeholder="Enter Email Address" fullWidth />
                        </div>

                        {/* Contact Phone */}
                        <div className="control_group w_50">
                            <label htmlFor="contact_phone">Contact Phone</label>
                            <PhoneInput
                                inputProps={{ id: "contact_phone", name: "contact_phone" }}
                                country={"ae"}
                                placeholder="Enter Phone Number"
                                inputStyle={{ width: "100%" }}
                            />
                        </div>

                        {/* License Number */}
                        <div className="control_group w_50">
                            <label htmlFor="license_number">License Number</label>
                            <TextField id="license_number" placeholder="Enter License Number" fullWidth />
                        </div>
                        <div className="control_group w_50">
                            <label htmlFor="pin">Generate temporary password & force reset</label>
                            <TextField
                                id="pin"
                                placeholder="Enter passowrd"
                                fullWidth
                                hiddenLabel
                            />
                        </div>
                        {/* Store Address (Emirate) */}
                        <div className="control_group w_50">
                            <label htmlFor="store_address">Store Address (Emirate)</label>
                            <Select id="store_address" fullWidth displayEmpty>
                                <MenuItem value="">Select</MenuItem>
                                <MenuItem value="dubai">Dubai</MenuItem>
                                <MenuItem value="abu_dhabi">Abu Dhabi</MenuItem>
                                <MenuItem value="sharjah">Sharjah</MenuItem>
                            </Select>
                        </div>

                        {/* Category */}
                        <div className="control_group w_50">
                            <label htmlFor="category">Category</label>
                            <Select id="category" fullWidth displayEmpty>
                                <MenuItem value="">Select Category</MenuItem>
                                <MenuItem value="fashion">Fashion</MenuItem>
                                <MenuItem value="electronics">Electronics</MenuItem>
                                <MenuItem value="home">Home & Living</MenuItem>
                            </Select>
                        </div>

                        {/* Sub Category */}
                        <div className="control_group w_50">
                            <label htmlFor="sub_category">Sub-Category</label>
                            <Select id="sub_category" fullWidth displayEmpty>
                                <MenuItem value="">Select Sub-Category</MenuItem>
                                <MenuItem value="mens">Men</MenuItem>
                                <MenuItem value="womens">Women</MenuItem>
                                <MenuItem value="kids">Kids</MenuItem>
                            </Select>
                        </div>

                        {/* Store Bio */}
                        <div className="control_group w_100 ai_rec_btn">
                            <label htmlFor="store_bio">Store Bio (250 characters maximum)</label>
                            <TextField
                                id="store_bio"
                                placeholder="Enter Store Bio"
                                multiline
                                rows={4}
                                fullWidth
                                inputProps={{ maxLength: 250 }}
                            />

                            <div className="bio_actions">
                                <Select size="small" displayEmpty inputProps={{ 'aria-label': 'Select Template' }}>
                                    <MenuItem value="">Select Template</MenuItem>
                                    <MenuItem value="professional">Professional</MenuItem>
                                    <MenuItem value="friendly">Friendly</MenuItem>
                                    <MenuItem value="luxury">Luxury</MenuItem>
                                </Select>

                                <Button className="btn btn_primary sm">
                                    ✨ Generate My Bio With AI
                                </Button>
                            </div>
                        </div>

                    </div>

                    {/* Footer */}
                    <div className="form_btn mt_30">
                        <Button className="btn btn_primary">Save</Button>
                    </div>

                </div>


            </div>
        </>
    );
};

export default AddVendor;
